import { fmtUSD } from '@/lib/format';

/* SVG charts ported from the Cafe Receipts design (components.jsx). */

export function Donut({
  slices,
  size = 180,
  thickness = 26,
}: {
  slices: { value: number; color: string }[];
  size?: number;
  thickness?: number;
}) {
  const r = (size - thickness) / 2;
  const c = size / 2;
  const total = slices.reduce((s, x) => s + x.value, 0) || 1;
  const circ = 2 * Math.PI * r;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={c} cy={c} r={r} stroke="var(--bg-2)" strokeWidth={thickness} fill="none" />
      {slices.map((s, i) => {
        const frac = s.value / total;
        const prior = slices.slice(0, i).reduce((sum, x) => sum + x.value, 0) / total;
        const dash = frac * circ;
        const offset = -prior * circ;
        return (
          <circle
            key={i}
            cx={c}
            cy={c}
            r={r}
            stroke={s.color}
            strokeWidth={thickness}
            fill="none"
            strokeDasharray={`${dash} ${circ - dash}`}
            strokeDashoffset={offset}
            transform={`rotate(-90 ${c} ${c})`}
          />
        );
      })}
    </svg>
  );
}

export function MiniBars({
  data,
  max,
  height = 130,
}: {
  data: { label: string; value: number }[];
  max?: number;
  height?: number;
}) {
  const m = max || Math.max(...data.map((d) => d.value), 1);
  return (
    <div className="trend-bars" style={{ height }}>
      {data.map((d, i) => (
        <div key={i} className="c">
          <div
            className="b"
            style={{ height: `${(d.value / m) * 100}%` }}
            data-value={fmtUSD(d.value)}
            title={`${d.label}: ${fmtUSD(d.value)}`}
          />
          <div className="l">{d.label}</div>
        </div>
      ))}
    </div>
  );
}
